
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenFullExitGoogle as ObiScreenFullExitGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-full-exit-google.js';
 
 
 

 
 export const ObiScreenFullExitGoogle = createComponent({
   react: React,
   tagName: 'obi-screen-full-exit-google',
   elementClass: ObiScreenFullExitGoogleElement,
   events: {
     
   }
  });
 
 